import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M4.24004 53.77C4.24004 53.77 7.61006 46.86 8.88006 40.88C11.1801 29.99 12.99 24.05 17.62 21.24C17.62 21.24 24.06 21.9 35.79 21.74C48.02 21.57 52.0601 21.08 52.0601 21.08L59.5101 14.85C59.5101 14.85 57.7701 10.26 55.7801 8.36999C52.3101 5.06999 47.5201 1.09993 33.3201 1.42993C18.7901 1.76993 10.2001 8.36992 6.07006 15.2999C2.05006 22.0399 -1.03996 35.44 4.24004 53.77Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M59.5001 14.84C61.7101 14.88 65.1601 17.34 66.5001 20.91C69.4701 28.84 69.8701 41.96 66.1101 53.77C66.1101 53.77 63.0602 48.5799 61.5502 41.7999C58.7402 29.1699 57.4201 23.88 51.6401 21.08L59.5001 14.84Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M55.6602 18.22C55.6602 18.22 59.4801 19.29 62.4901 26.48C64.9601 32.37 65.5101 38.79 67.9901 40.42"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M57.97 16.89C57.97 16.89 62.59 17.5499 64.75 24.0599C66.58 29.5599 67.49 33.63 68.48 33.63"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M61.52 30.37C62.01 33.09 62.71 35.78 63.71 38.33C64.22 39.6 64.82 40.8399 65.6 41.9299C66.36 43.0099 67.3899 43.95 68.5699 44.12L68.39 45.1C66.79 44.75 65.72 43.52 64.98 42.34C64.22 41.13 63.69 39.82 63.24 38.5C62.38 35.85 61.84 33.12 61.52 30.37Z"
        fill={outline}
      />
      <path
        d="M17.23 20.97C17.23 20.97 14.5901 20.75 10.0701 26.47C7.36007 29.9 4.18006 32.2901 1.81006 33.4101"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M11.4001 29.4399C11.4001 29.4399 6.55007 37.61 2.57007 38.54"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.78009 38.3099C9.78009 38.3099 7.01006 44.79 3.31006 46.95"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M36.83 21.52C36.83 21.52 27.1199 3.3999 12.6899 8.3099"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M41.45 21.85C41.45 21.85 35.28 3.46006 21.74 4.13006"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M43.9901 21.41C43.9901 21.41 41.3501 6.22 32.5901 3.87"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M49.9301 20.86C49.9301 20.86 43.1001 1.48003 23.8401 3.03003" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M53.72 19.97C53.72 19.97 57.45 8.05994 49.74 4.55994"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33.2 21.2999C33.2 21.2999 27.62 12.26 18.66 12.51C11.4 12.71 8.95999 19.05 3.48999 19.28"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M26.1201 20.17C24.6301 18.69 22.6201 17.87 20.6101 17.53C18.5801 17.21 16.5001 17.44 14.5401 18C13.5401 18.21 12.6101 18.6599 11.6501 18.9899C10.7201 19.4199 9.8001 19.8699 8.9101 20.3499C8.0401 20.8999 7.15011 21.3999 6.30011 21.9699L3.81012 23.78L2.64014 22.16L5.37012 20.4899C6.30012 19.9599 7.27009 19.51 8.22009 19.02C9.20009 18.59 10.2001 18.1899 11.2001 17.8199C12.2401 17.5399 13.2401 17.16 14.3101 17.02C16.4101 16.61 18.6101 16.54 20.6901 17.04C22.7701 17.56 24.7501 18.58 26.1201 20.17Z"
        fill={outline}
      />
      <path
        d="M41.1002 1.20996C42.7302 1.63996 44.1102 2.43004 45.3602 3.42004C46.6102 4.41004 47.6502 5.61994 48.5002 6.93994C49.3102 8.28994 49.9302 9.72998 50.3502 11.23C50.5802 11.97 50.6902 12.74 50.8602 13.5L51.1302 15.7999L50.7402 13.52C50.5302 12.78 50.3802 12.0199 50.1102 11.2999C49.6102 9.84993 48.9301 8.46997 48.0801 7.21997C47.1901 5.98997 46.1402 4.89002 44.9102 4.02002C43.7002 3.16002 42.2902 2.47994 40.9102 2.18994L41.1002 1.20996Z"
        fill={outline}
      />
    </g>
  )
}
